/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.17",
    versionName: "0.2.0-nightly.2026.3.17",
    versionChannel: "nightly",
    buildDate: "2026-03-17T00:10:59.094Z",
    commitHash: "5f30f312e9c0cb3cb36de62dade51851c3ef6c05",
};
